// extracted by mini-css-extract-plugin
export default {"core":"core_core__gOUmV"};